import React, { useState } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";
import { toast, Bounce } from "react-toastify";

const ManageDemoAccountMuvi5 = ({ data, setApiRun }) => {
	const { fetchPostData, error } = useFetchPost();
	const handleClose = () => {
		const manageDemoAccountClassicModal = document.getElementById("manageDemoAccountClassicModal");
		manageDemoAccountClassicModal.classList.remove("show");
		manageDemoAccountClassicModal.style.display = "none";
	};

	// Function to handle data submission
	const handleSubmit = async () => {
		// Process the data or perform any actions
		const postData = {
			product_key: data && data.product_key,
			app_token: data && data.customer_id,
			id: data && data.customer_id,
			is_demo: data && data.is_demo,
			is_live: data && data.isLive,
		};
		let crmStagingUrl;
		if (data && data.is_demo) {
			crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/move-to-demo";
		} else {
			crmStagingUrl = process.env.REACT_APP_CRM + "/muvi5/move-from-demo";
		}

		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}

		if (responseData && responseData.status == "OK") {
			setApiRun(true);

			toast.success(responseData.msg, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
		} else {
			const errorMessage = responseData && responseData.msg ? responseData.msg : "An error occurred";

			toast.error(errorMessage, {
				position: "top-right",
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "light",
				transition: Bounce,
			});
			// Action to take if user clicks "Cancel" or closes the dialog
			console.warn("Something went wrong to move demo.");
		}

		// Close the modal
		const manageDemoAccountClassicModal = document.getElementById("manageDemoAccountClassicModal");
		manageDemoAccountClassicModal.classList.remove("show");
		manageDemoAccountClassicModal.style.display = "none";
	};

	return (
		<div
			className="modal fade"
			id="manageDemoAccountClassicModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="manageDemoAccountClassicModalLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="manageDemoAccountClassicModalLabel">
							Move {data && data.is_demo ? "To" : "From"} Demo Account
						</h4>
					</div>
					<div className="modal-body">
						<h4>{data && data.confirmText}</h4>
					</div>
					<div className="modal-footer">
						<a type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</a>
						<a type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
							Submit
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ManageDemoAccountMuvi5;



// WEBPACK FOOTER //
// ./src/components/crm/modals/ManageDemoAccountMuvi5.jsx